import axios from 'axios'
import router from 'vue-router'
import store from '@/store'
import izitoast from 'izitoast'
import { Trans } from '@/plugins/Translations'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.credentials = 'same-origin'
axios.defaults.mode = 'no-cors'
axios.defaults.crossDomain = true

// Request interceptor
axios.interceptors.request.use(request => {
  request.baseURL = process.env.VUE_APP_IS_MULTI_DOMAIN
    ? `${window.location.origin}/api/`
    : process.env.VUE_APP_BACKEND_URL
  let token = store.getters['auth/token']
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  request.headers['Accept-Language'] = Trans.currentLanguage
  request.headers['x-ui-host'] = window.location.host
  return request
})

const processFailedResponse = ({ status, data }) => {
  if (status >= 500) {
    console.log('🔥 Error 500')
  }
  if (status === 401) {
    store.dispatch('auth/logout')
    router.push({ name: 'login' })
  }
  if (status === 422 || status === 429) {
    const message = `
      <ul class="m-0 pl-2 list-style-none">
          ${Object.entries(data.errors).map(([field, value]) => `<li>${value[0]}</li>`).join('')}
      </ul>
    `
    izitoast.show({
      id: 'haduken',
      theme: 'dark',
      displayMode: 2,
      message,
      position: 'topCenter',
      transitionIn: 'flipInX',
      transitionOut: 'flipOutX',
      progressBarColor: 'rgb(0, 255, 184)',
      layout: 2,
      iconColor: 'rgb(0, 255, 184)',
    })
  }
}

// Response interceptor
axios.interceptors.response.use(
  (res) => {
    const { data: { data, error } } = res
    if (error === 1) {
      return Promise.reject(data)
    }
    return Promise.resolve(data)
  },
  error => {
    const { response: { status, data } } = error
    processFailedResponse({ status, data })
    return Promise.reject(data)
  }
)
